import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";

import SessionFormInput from "@ats/src/views/sessions/components/SessionFormInput";
import FormContainer from "@ats/src/components/forms/FormContainer";
import SessionButton from "@ats/src/views/sessions/components/SessionButton";
import Styled from "@ats/src/views/sessions/components/Styled";
import FormLogoHeader from "@ats/src/views/sessions/components/FormLogoHeader";
import SessionsLayout from "@ats/src/views/sessions/components/SessionsLayout";

import { useSendPasswordResetEmail } from "@shared/queryHooks/useSession";
import { validateEmail } from "@shared/lib/validateWithYup";
import { useToastContext } from "@shared/context/ToastContext";

function PasswordResetRequest(props) {
  const [email, setEmail] = React.useState("");
  const [errors, setErrors] = React.useState(null);
  const addToast = useToastContext();

  const { mutate: sendPasswordResetEmail, isLoading } = useSendPasswordResetEmail();

  const handleFormInputChange = (name, value) => {
    setEmail(value);
  };

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    window.logger("%c[PasswordResetRequest] handleSubmitForm", "color: #1976D2", { email });

    // Trim email and update state
    const trimmedEmail = email.trim();
    setEmail(trimmedEmail);

    const [isValid, validationErrors] = await validateEmail({ email: trimmedEmail });

    if (isValid) {
      sendPasswordResetEmail(
        { email: trimmedEmail },
        {
          onSuccess: () => {
            setEmail("");
            setErrors(null);
            addToast({ title: `Password reset email sent`, kind: "success" });
          },
          onError: (response: any) => {
            setErrors(response.data.errors);
          },
        },
      );
    } else {
      setErrors(validationErrors);
    }
  };

  const submitButton = (
    <SessionButton type="submit" disabled={isLoading} loading={isLoading}>
      Submit request
    </SessionButton>
  );

  return (
    <SessionsLayout>
      <Styled.FormContentWrapper>
        <Styled.Form>
          <Helmet title="Reset password" />
          <FormLogoHeader />
          <h2>Request password reset</h2>
          <FormContainer onSubmit={handleSubmitForm} errors={errors} buttons={submitButton}>
            <SessionFormInput
              onChange={handleFormInputChange}
              name="email"
              placeholder=""
              label="Email address"
              inputType="email"
              value={email}
              errors={errors}
            />
          </FormContainer>
        </Styled.Form>
        <Styled.Links>
          <Link to="/login">Log in by password</Link>
          <Link to="/auth">Log in by email link</Link>
        </Styled.Links>
      </Styled.FormContentWrapper>
    </SessionsLayout>
  );
}

export default withRouter(PasswordResetRequest);
